import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Fade from 'react-reveal/Fade'; 
import Typography from '@material-ui/core/Typography';

const styles = theme => ({

})
class Connected extends React.Component{
    render(){
        const { classes } = this.props;
        return(
            <Grid  container
                direction="row"
                justify="center"
                alignItems="center" id="section1" style={{ height: '100vh'}}
                >
                <Grid item md={6} xs={12} className="connect">
                    <Fade top cascade>
                        <Typography component="h2" style={{fontWeight: 600}}>
                            They are connected
                        </Typography>
                    </Fade>
                    <Fade bottom cascade>
                        <Typography variant="caption" component="p">
                            They are connected, they are digital, they are mobile and always be connected to their friends.
                        </Typography>
                    </Fade>
               </Grid>
            </Grid>
        )
    }
}
export default withStyles(styles)(Connected);